import { render, staticRenderFns } from "./minerva.vue?vue&type=template&id=497ddb9e&scoped=true&"
import script from "./minerva.vue?vue&type=script&lang=js&"
export * from "./minerva.vue?vue&type=script&lang=js&"
import style0 from "./minerva.vue?vue&type=style&index=0&id=497ddb9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497ddb9e",
  null
  
)

export default component.exports